module.exports = __webpack_public_path__ + "img/arrow-horizontal.58585068.svg";